import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";
import { getGuideAccent } from "../../utils/guideAccent";

// Template319 (Edimburgo, copia de 119): Westminster - Big Ben, Parlamento, Abadía (Page15 guia-londres)
const Template319 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page.texts?.[0]?.content;
	const logoImage = page.canvasImages?.find(
		(img) => img.id === "logo",
	)?.imageUrl;

	console.log(logoImage);
	const introText = page.texts?.[1]?.content;
	const heroTitle = page.texts?.[2]?.content;

	const getImageSrc = (id) => {
		if (page.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found && found.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found && found.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const sections = Array.isArray(page?.sections)
		? page.sections
		: Array.isArray(page?.data?.sections)
			? page.data.sections
			: Array.isArray(page?.data?.data?.sections)
				? page.data.data.sections
				: [];
	const bigBen = sections[0];
	const parlamento = sections[1];
	const abadia = sections[2];
	const reserva =
		page?.reserva ?? page?.data?.reserva ?? page?.data?.data?.reserva;

	const heroImage = getImageSrc("westminster");
	const westminsterSticker = getCanvasImageUrl("westminster-sticker");
	const bigBenImage = getImageSrc("big-ben");
	const parlamentoImage = getImageSrc("parlamento");
	const abadiaImage = getImageSrc("abadia");
	const abadiaSticker = getCanvasImageUrl("abadia-sticker");

	const actualHeaderColor = headerBackgroundColor || "#de5624";
	const accent = getGuideAccent(actualHeaderColor);
	const contentColor = textColor || "#444";

	const h3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};

	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: contentColor,
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
			}}
		>
			{/* CABECERA */}
			{headerText && (
				<Box
					data-block-id="header"
					data-template-header
					sx={{
						backgroundColor: actualHeaderColor,
						color: headerTextColor || "#fff",
						textAlign: "center",
						padding: "15px 0",
						fontSize: "14px",
						fontWeight: 600,
						flexShrink: 0,
						position: "sticky",
						top: 0,
						zIndex: 99999,
					}}
				>
					{headerText}
					{logoImage && (
						<Box
							component="img"
							src={logoImage}
							alt="logo"
							sx={{
								width: isSmallScreen ? 66 : 80,
								position: "absolute",
								right: 2,
								top: 18,
								zIndex: 999999,
							}}
						/>
					)}
				</Box>
			)}

			{/* HERO */}
			<Box data-block-id="image-0" sx={{ position: "relative" }}>
				{heroImage && (
					<img
						src={heroImage}
						alt=""
						style={{ width: "100%", height: 200, objectFit: "cover" }}
					/>
				)}
				{westminsterSticker && (
					<img
						src={westminsterSticker}
						alt=""
						style={{
							width: isSmallScreen ? 80 : 100,
							position: "absolute",
							bottom: isSmallScreen ? 60 : -10,
							right: isSmallScreen ? "auto" : 0,
							left: isSmallScreen ? 25 : "auto",
						}}
					/>
				)}
				{heroTitle && (
					<Box
						component="h1"
						sx={{
							fontSize: 32,
							textAlign: "center",
							position: "absolute",
							bottom: 0,
							margin: 1.25,
							left: 20,
							color: "#fff",
							textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
						}}
					>
						{heroTitle}
					</Box>
				)}
			</Box>
			{introText && (
				<Box data-block-id="text-1" sx={{ padding: "10px 12px" }}>
					<Box component="p" sx={p}>
						{introText}
					</Box>
				</Box>
			)}
			<Box>
				{/* Big Ben */}
				{(bigBen?.title || bigBen?.body) && (
					<Box
						data-block-id="text-2"
						sx={{
							display: "flex",
							gap: 2,
							padding: "0 12px",
							position: "relative",
						}}
					>
						{bigBenImage && (
							<img
								src={bigBenImage}
								alt={bigBen?.title}
								style={{
									width: "40%",
									height: 100,
									objectFit: "cover",
									borderRadius: 12,
								}}
							/>
						)}
						<Box sx={{ width: "60%" }}>
							{bigBen?.title && (
								<Box component="h3" sx={h3}>
									{bigBen.title}
								</Box>
							)}
							{bigBen?.body && (
								<Box component="p" sx={p}>
									{bigBen.body}
								</Box>
							)}
						</Box>
						<Box sx={{ position: "absolute", bottom: 0, left: "34%" }}>
							{bigBen?.sabiasQue?.[0] && (
								<SabiasQue
									icono={bigBen.sabiasQue[0].icono}
									texto={bigBen.sabiasQue[0].texto}
								/>
							)}
						</Box>
					</Box>
				)}

				{/* Parlamento */}
				{(parlamento?.title || parlamento?.body) && (
					<Box
						data-block-id="text-3"
						sx={{
							display: "flex",
							gap: 2,
							padding: "0 12px",
							marginTop: 1.75,
						}}
					>
						{parlamentoImage && (
							<img
								src={parlamentoImage}
								alt={parlamento?.title}
								style={{
									width: "40%",
									height: 100,
									objectFit: "cover",
									borderRadius: 12,
								}}
							/>
						)}
						<Box sx={{ width: "60%" }}>
							{parlamento?.title && (
								<Box component="h3" sx={h3}>
									{parlamento.title}
								</Box>
							)}
							{parlamento?.body && (
								<Box component="p" sx={p}>
									{parlamento.body}
								</Box>
							)}
						</Box>
					</Box>
				)}

				{/* Abadía */}
				{(abadia?.title || abadia?.body) && (
					<Box
						data-block-id="text-4"
						sx={{
							display: "flex",
							gap: 2,
							padding: "0 12px",
							marginTop: 1.75,
							position: "relative",
						}}
					>
						{abadiaImage && (
							<img
								src={abadiaImage}
								alt={abadia?.title}
								style={{
									width: "40%",
									height: 100,
									objectFit: "cover",
									borderRadius: 12,
								}}
							/>
						)}
						<Box sx={{ width: "60%" }}>
							{abadia?.title && (
								<Box component="h3" sx={h3}>
									{abadia.title}
								</Box>
							)}
							{abadia?.body && (
								<Box component="p" sx={p}>
									{abadia.body}
								</Box>
							)}
						</Box>
						<Box
							sx={{
								position: "absolute",
								bottom: isSmallScreen ? 0 : -10,
								right: isSmallScreen ? "58%" : "26%",
								zIndex: 90,
							}}
						>
							{abadia?.sabiasQue?.[0] && (
								<SabiasQue
									icono={abadia.sabiasQue[0].icono}
									texto={abadia.sabiasQue[0].texto}
								/>
							)}
						</Box>
						<Box
							sx={{
								position: "absolute",
								bottom: isSmallScreen ? 70 : -10,
								right: isSmallScreen ? "58%" : "33%",
								zIndex: 90,
							}}
						>
							{abadia?.sabiasQue?.[1] && (
								<SabiasQue
									icono={abadia.sabiasQue[1].icono}
									texto={abadia.sabiasQue[1].texto}
								/>
							)}
						</Box>
						{abadia?.tooltip &&
							(abadia.tooltip.titleShort || abadia.tooltip.titleLong) && (
								<Box
									sx={{
										position: "absolute",
										bottom: isSmallScreen ? 160 : 80,
										left: 5,
										backgroundColor: accent.tooltipBg,
										border: "2px solid #f5c400",
										borderRadius: "16px 16px 16px 0px",
										padding: "10px 12px",
										fontSize: 11,
										color: contentColor,
										boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
										maxWidth: 120,
										zIndex: 3,
									}}
								>
									<strong>
										{isSmallScreen
											? abadia.tooltip.titleShort
											: abadia.tooltip.titleLong}
									</strong>
								</Box>
							)}
						{abadiaSticker && (
							<img
								src={abadiaSticker}
								alt=""
								style={{
									width: 100,
									position: "absolute",
									bottom: isSmallScreen ? 80 : -10,
									left: -30,
								}}
							/>
						)}
					</Box>
				)}

				{/* Caja reserva Abadía */}
				{reserva && (reserva.title || reserva.body || reserva.url) && (
					<Box sx={{ padding: "0 12px", paddingTop: 1.75 }}>
						<Box
							sx={{
								backgroundColor: accent.boxBg,
								padding: 1.5,
								borderRadius: 2,
								display: "flex",
								gap: 2,
								alignItems: "center",
							}}
						>
							<Box sx={{ width: "100%" }}>
								<Box component="p" sx={p}>
									{reserva.title && <strong>{reserva.title}</strong>}{" "}
									{reserva.body}{" "}
									{reserva.url && reserva.linkText && (
										<a
											href={reserva.url}
											target="_blank"
											rel="noopener noreferrer"
											style={{
												display: "inline-block",
												marginTop: 8,
												color: "#0077cc",
												textDecoration: "underline",
												fontWeight: 500,
											}}
										>
											{reserva.linkText}
										</a>
									)}
								</Box>
							</Box>
						</Box>
					</Box>
				)}
			</Box>
		</Box>
	);
};

export default Template319;
